import type { Store } from 'store/types/types';

export const getCurrency = (state: Store) => state?.user?.currency;
